import { render, staticRenderFns } from "./kr-math.vue?vue&type=template&id=00b0b0d0&"
import script from "./kr-math.vue?vue&type=script&lang=js&"
export * from "./kr-math.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports